<div class="d-flex justify-content-center home-container" *ngIf="showPage">
  <div class="background"></div>
  <div class="overlay" *ngIf="!isMobile"></div>
  <div class="column fondo">
    <div class="d-flex flex-row">
      <div class="col-12 col-md-10 col-lg-8 fondo-description">
        <h1 *ngIf="!isNotProd">Sistema de Administraci&oacute;n de Despacho y Retiro en Tienda</h1>
        <h1 *ngIf="isNotProd">Sistema de Prueba de Administraci&oacute;n de Despacho y Retiro en Tienda</h1>
        <div class="d-flex flex-column options col-12">
          <div 
            *ngFor="let menuLists of menuListGroup"
            class="d-flex flex-row justify-content-left align-items-stretch flex-wrap menuLists">
            <div 
              *ngFor="let menu of menuLists" 
              class="col-12 col-md-4 col-lg-4 col-sm-12">
              <a [routerLink]="menu.link"
                [id]="'home_menu_' + menu.module"
                [title]="menu.description"
                class="option-module p-2">
                <div class="d-flex flex-row align-items-start">
                  <span>
                    <mat-icon *ngIf="!menu.iconSVG">{{menu.icon}}</mat-icon>
                    <mat-icon *ngIf="menu.iconSVG" [svgIcon]="menu.iconSVG" class="icon-white"></mat-icon>                  
                  </span>
                  <div class="d-flex flex-column ms-2 option-module-title">
                    <label>{{ menu.name }}</label>
                    <span class="description-module">{{menu.subtitle}}</span>
                  </div>           
                  
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>      
    </div>    
  </div>
  <div
  *ngIf="!isMobile"
  class="d-flex fixed-bottom justify-content-end img-background">
      <img
        src="../../assets/home/background/background.png"
        alt="img"
        class="img-fluid"/>        
    </div>  
  <div *ngIf="!isMobile"
  class="d-flex fixed-bottom justify-content-end img-background-vector">
    <img
        src="../../assets/home/background/footer.svg"
        alt="img"
        class="img-fluid-vector"
        />
  </div>
  <div class="d-inline-flex fixed-top justify-content-start img-background-top">
    <img
        src="../../assets/home/background/header.svg"
        alt="img"
        />
  </div>
</div>
